import React, { useEffect,useState } from "react";
// import { actions } from "../../actions";
// import { useSelector, useDispatch } from "react-redux";
import { Modal } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";

import "./qsetdashboard.scss";
import QSETDashboardEvalCard from "../qsetdashboardevalcard";
import useQSetStore from "../../store/qset.store";


function QSETDashboard() {
  const location = useLocation();
    const qsetUserDetails = JSON.parse(localStorage.getItem("qsetUserDetails"));
    const { getMyEval,getMyApplication,getMyoffer,myEvals,myQuestions } = useQSetStore();
    
    const navigate = useNavigate();
    useEffect(() => {
        getMyEval(qsetUserDetails.sessionid)
        getMyApplication(qsetUserDetails.sessionid)
        //getMyoffer()
     }, [location.pathname]);


    const getQuestionsArray = (evID) =>{
        var qArr =  myQuestions.filter((item)=> item.qhevid == evID)
        return qArr?.qdescarray
    }

    return (
        <div className="qsetdashboard-wrapper">
            You Have ({myEvals?.evals?.length}) Assessment
              <div style={{ marginTop: 20 }}>
                {myEvals?.evals?.map((item,idx) => (                                                        
          <QSETDashboardEvalCard
            key={idx}
            evalItem={item}
            questionsArray={getQuestionsArray(item.evID)}
          />
        ))}
      </div>
      <div className="eval-container">
        <div className="eval-item">
          #1. Kindly note that once the Evaluation is started you need to
          complete it. You can not take it again.
        </div>
        <div className="eval-item">
          #2. Online Camera is started to detect any wrongdoing, kindly close
          all other browers/windows and all the time look towards the screen.
        </div>
        <div className="eval-item">
          #3. If Camera is not avilable, test will not be started.
        </div>
        <div className="eval-item">
          #4. Test Score will not be disclosed. HR will call you back based on
          the results of the test and suitability
        </div>
        <div className="eval-item">
          #5. Appearance in the test does not gurantee the job offer.
        </div>
      </div>
    </div>
  );
}

export default QSETDashboard;
